import React, {Component} from 'react';
import Popup from "../../../components/popup";

import { ButtonCancel, ButtonProceed, ButtonReturn } from '../../../components/buttons';

import PopupContext from '../../../context/context-popup';
import Container from '../../../layouts/containers/container';
import InputsTextarea from '../../../components/inputs/inputs-text-area';

import List from '../../../components/list';
import meetingsApi from '../../../lib/meetings/meetings-api';
import alertManager from '../../../managers/alert/alert-manager';
import LabelContainer from '../../../components/label-container';
import ErrorContainer from '../../../components/error-container';
import Cross from '../../../components/buttons/cross';
import dayjs from 'dayjs';

import isBetween from 'dayjs/plugin/isBetween';

import humanizeDuration from 'humanize-duration';
import eventsApi from '../../../lib/events/events-api';
import InputsDropdown from '../../../components/inputs/inputs-dropdown';
import InputsText from '../../../components/inputs/inputs-text';
import companiesApi from '../../../lib/companies/companies-api';
import adminApi from '../../../lib/admin/admin-api';
import { SmallPill } from '../../../components/pills';
import Row from '../../../components/row';

dayjs.extend(isBetween)

export default class PopupsInviteUser extends Component {
    static contextType = PopupContext;

    constructor(props) {
        super(props);

        this.state = {
            email: null,
            role_ids: [
                null,
            ],
            roles: [],
            errors: {}
        }
    }

    componentDidMount() {
        adminApi.getRoles().then(({ data }) => {
            const newRoles = [
                ...data,
                {
                    name: 'Staff',
                    id: null,
                }
            ]
            this.setState({ roles: newRoles });
        });
    }

    update() {
        companiesApi.inviteUser(window.user?.company_id, {
            email: this.state.email,
            role_ids: this.state.role_ids?.filter(val => val !== null)
        }, (errors) => {
            this.setState({ errors })
        }).then(() => {
            this.props.onSuccess();
            this.context.closePopup();
        })
    }

    onRoleAdd(id) {
        const role_ids = [ ...this.state.role_ids ];

        if (!role_ids.includes(id)) role_ids.push(id);

        this.setState({ role_ids })
    }

    onRoleDelete(id) {
        let role_ids = [ ...this.state.role_ids ];

        role_ids = role_ids.filter((role) => role !== id);

        this.setState({ role_ids })
    }

    render() {
        return (
            <Popup>
                <Popup.Content>
                    <Container.Text fontSize="30px" color="#151515">Invite a user to your company</Container.Text>

                    <List gap="20px">
                        <InputsText
                            label="Email"
                            value={this.state.email}
                            errors={this.state.errors?.email}
                            onChange={e => this.setState({ email: e.target.value })}
                        />

                        <InputsDropdown
                            label="Roles"
                            value={undefined}
                            items={
                                this.state.roles?.map((role) => {
                                    return {
                                        label: role?.name,
                                        value: role?.id
                                    }
                                })
                            }
                            onChange={(e) => this.onRoleAdd(e.value)}
                            errors={this.state.errors?.role_ids}
                        />

                        <Row gap="10px">
                            { this.state.role_ids?.map((id, index) => {
                                const role = this.state.roles?.find(r => r.id === id);

                                return <SmallPill removable={true} key={index} onRemoveClick={() => this.onRoleDelete(id)}>{ role?.name }</SmallPill>
                            })}
                        </Row>
                    </List>
                </Popup.Content>

                <Popup.Buttons className="invite-user__buttons">
                    <ButtonProceed onClick={this.update.bind(this)}>Invite</ButtonProceed>
                    <ButtonReturn onClick={this.context.closePopup} rightIcon={<Cross/>}>Return</ButtonReturn>
                    <ButtonProceed>Contact us to discuss</ButtonProceed>
                </Popup.Buttons>
            </Popup>
        );
    }
}
